import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classnames from 'classnames';
import React from 'react';
var clsPrefix = 'zhb-linear-gradient-block';
export var ZhbGradientBlock = function ZhbGradientBlock(props) {
  var _props$padding = props.padding,
    padding = _props$padding === void 0 ? 3 : _props$padding,
    className = props.className,
    style = props.style,
    linearGradient = props.linearGradient,
    conicGradient = props.conicGradient,
    children = props.children,
    contentRadius = props.contentRadius,
    contentClassName = props.contentClassName,
    contentBg = props.contentBg,
    contentStyle = props.contentStyle,
    _props$radius = props.radius,
    radius = _props$radius === void 0 ? 0 : _props$radius;
  return React.createElement("div", {
    className: classnames(clsPrefix, className),
    style: _objectSpread({
      padding: padding,
      background: linearGradient || conicGradient,
      borderRadius: radius
    }, style)
  }, React.createElement("div", {
    className: classnames("".concat(clsPrefix, "-content"), contentClassName),
    style: _objectSpread({
      background: contentBg,
      borderRadius: contentRadius
    }, contentStyle)
  }, children));
};